import { useEffect, useState } from "react";
import { fetchHousehold } from "../lib/api";
import { getHousehold } from "../lib/household";
import { logError } from "../lib/log";

let cache = null;
let cacheSlug = null;
let pending = null;

const hexToHsl = (hex) => {
  const m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
  if (!m) return null;
  const [r, g, b] = [1, 2, 3].map((i) => parseInt(m[i], 16) / 255);
  const max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
  if (max === min) return `0 0% ${Math.round(l * 100)}%`;
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
  h = Math.round(h * 60);
  return `${h} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export const applyAccent = (hex) => {
  const hsl = hexToHsl(hex);
  const root = document.documentElement;
  if (hsl) root.style.setProperty("--primary", hsl);
  else root.style.removeProperty("--primary");
};

export const useBranding = () => {
  const slug = getHousehold();
  const [info, setInfo] = useState(cacheSlug === slug ? cache : null);
  useEffect(() => {
    if (!slug) {
      cache = null; cacheSlug = null; pending = null;
      applyAccent(null);
      return;
    }
    if (cacheSlug === slug && cache) { applyAccent(cache?.branding?.accent); return; }
    if (cacheSlug !== slug) { cache = null; pending = null; cacheSlug = slug; }
    pending = pending || fetchHousehold();
    pending
      .then((d) => {
        cache = d;
        setInfo(d);
        applyAccent(d?.branding?.accent);
      })
      .catch((e) => logError("household info", e));
  }, [slug]);
  return info;
};

export const resetBrandingCache = () => {
  cache = null;
  cacheSlug = null;
  pending = null;
};
